// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"154":"0b34846d","335":"04123b0f"}[chunkId] + ".chunk.css";
};